/**
 * catalog.ts — CATALOG map of component name → component function.
 *
 * Kept separate from ComponentCatalog.tsx so that the component file
 * only exports React components (fast-refresh requirement).
 */
import type { ReactNode } from 'react'
import {
  Page,
  Section,
  Grid,
  Stack,
  Card,
  Heading,
  Text,
  Stat,
  Table,
  LineChart,
  BarChart,
  Badge,
  Alert,
} from './ComponentCatalog'

type ComponentFn = (props: Record<string, unknown> & { children?: ReactNode }) => React.ReactElement | null

export const CATALOG: Record<string, ComponentFn> = {
  Page:      (props) => Page(props as Parameters<typeof Page>[0]),
  Section:   (props) => Section(props as Parameters<typeof Section>[0]),
  Grid:      (props) => Grid(props as Parameters<typeof Grid>[0]),
  Stack:     (props) => Stack(props as Parameters<typeof Stack>[0]),
  Card:      (props) => Card(props as Parameters<typeof Card>[0]),
  Heading:   (props) => Heading(props as Parameters<typeof Heading>[0]),
  Text:      (props) => Text(props as Parameters<typeof Text>[0]),
  Stat:      (props) => Stat(props as Parameters<typeof Stat>[0]),
  Table:     (props) => Table(props as Parameters<typeof Table>[0]),
  LineChart: (props) => LineChart(props as Parameters<typeof LineChart>[0]),
  BarChart:  (props) => BarChart(props as Parameters<typeof BarChart>[0]),
  Badge:     (props) => Badge(props as Parameters<typeof Badge>[0]),
  Alert:     (props) => Alert(props as Parameters<typeof Alert>[0]),
}
